import {Route,Routes} from 'react-router'
import Home from './Component/Pages/Home';
import Profile from './Component/Pages/Profile';
import PageDetails from './Component/Pages/PageDetails';
import ProductDetails from './Component/Pages/ProductDetails';
import Resturent from './Component/Pages/Resturent';
import Cart from './Component/Pages/Cart';
import PaymentPage from './Component/Pages/PaymentPage';
import CashChangePage from './Component/Pages/CashChangePage';
import SuccessPage from './Component/Pages/SuccessPage';
import Login from './Component/Pages/Login';
import Register from './Component/Pages/Register';
import ManagePage from './Component/Pages/ManagePage';
import SearchLocation from './Component/Pages/SearchLocation';
import MyLocation from './Component/Pages/MyLocation';
import Avatar from './Component/Pages/Avatar';
import MyOrders from './Component/Pages/MyOrders';
import FavoritePage from './Component/Pages/FavoritePage';
import Wallet from './Component/Pages/Wallet';
import Alerts from './Component/Pages/Alerts';
import Search from './Component/Pages/Search';

function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/profile' element={<Profile/>}/>
        <Route path="/page-details" element={<PageDetails/>} />
        <Route path="/product-details" element={<ProductDetails/>} />
        <Route path="/restuarents" element={<Resturent/>} />
        <Route path="/cart" element={<Cart/>} />
        <Route path="/checkout" element={<PaymentPage/>} />
        <Route path="/pay" element={<CashChangePage/>} />
        <Route path="/success-page" element={<SuccessPage/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/manage-page" element={<ManagePage/>} />
        <Route path="/search-location" element={<SearchLocation/>} />
        <Route path="/my-location" element={<MyLocation/>} />
        <Route path="/get-avature" element={<Avatar/>} />
        <Route path="/my-order" element={<MyOrders/>} />
        <Route path="/favorite" element={<FavoritePage/>} />
        <Route path="/wallet" element={<Wallet/>} />
        <Route path="/alerts" element={<Alerts/>} />
        <Route path="/explore" element={<Search/>} />
      </Routes>
    </div>
  );
}

export default App;
